<pages-container
  [title]="'main.events'"
  [icon]="'today'"
  [showSearch]="true"
  [showFilter]="true"
  (onSearchSent)="handleSearch($event)">
  <div buttons>
    @if (role() !== 'readOnly') {
      <button mat-raised-button
              [routerLink]="'/pages/event/detail'"
              class="mat-white-bg">
        <span>{{ 'event.add_new' | translate }}</span>
      </button>
    }

  </div>

  <app-filter filter-content [page]="'event'" [filters]="filterData()"
              [filterFromDB]="userFiltersFromDB()" (chooseFilter)="chooseFilters($event)"></app-filter>

  <div main-content class="table-container " id="eventPage">
    <mat-table class="products-table"
               #table
               [dataSource]="events()"
               matSort
               (matSortChange)="sortData($event)"
               (scroll)="onScroll($event)">

      <ng-container matColumnDef="title">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
          {{ 'canton.name' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let event" class="customWidthClass">
          <p class="text-truncate">{{ event.title }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="country">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'canton.country' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          @if (event.country?.flag) {
            <img style="height: 40px" [src]="'assets/images/' + event.country.flag + '.svg'"/>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canton">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'main.canton' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          <p class="text-truncate">{{ event.city?.name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="organization">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'main.organization' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          <p class="text-truncate">{{ event.organization?.name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="merge">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'main.subscription' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          @if (event.merge) {
            <div class="subscribed">
              <mat-icon class="secondary-text">swap_horizontal_circle</mat-icon>
              <p class="text-truncate">
                {{ event?.organization?.organizationType?.name }} {{ event?.organization?.name }}
              </p>
            </div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="archive">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header></mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          @if (event.oldEventId) {
            <mat-icon class="secondary-text">unarchive</mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="online">
        <mat-header-cell class="hide-on-mobile justify-center" *matHeaderCellDef mat-sort-header>
          {{ 'main.online' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile justify-center" *matCellDef="let event">
          <mat-icon [style.color]="event.online ? 'green' : 'red'"
                    [matTooltip]="(event.online ? 'event.event_published' : 'event.event_not_published') | translate">
            {{ event.online ? 'cloud_done' : 'cloud_off' }}
          </mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'organization.organizationType' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          <div class="type-indicator" [style.border-bottom]="'2px solid ' + event.eventType?.color">
            <span class="type-label" [style.background-color]="event.eventType?.color">&nbsp;</span>
            {{ event.eventType?.name }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'event.event_start' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let event">
          <p [matTooltip]="event.dateForShow" class="text-truncate">{{ event.dateForShow }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="counts">
        <mat-header-cell *matHeaderCellDef class="justify-center">
          {{ 'main.participanAndWaiting' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let event" class="justify-center">
          <div class="subscribed">
            @if (event.waitListCount > 0 || event.participantCount > 0) {
              <b class="text-xl" [style.color]="event.countColor">
                {{ event.participantCount }}
              </b>
            }
            @if (event.waitListCount > 0) {
              <b class="text-xl">/ {{ event.waitListCount }}</b>
            }
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="copy">
        <mat-header-cell class="hide-on-mobile customWidthClassIcon" *matHeaderCellDef></mat-header-cell>
        <mat-cell class="hide-on-mobile customWidthClassIcon" *matCellDef="let event">
          @if (!event.merge) {
            <button mat-icon-button
                    (click)="$event.stopPropagation(); copyEvent($event, event.id, event.merge)"
                    [matTooltip]="'event.copy_event' | translate">
              <mat-icon class="secondary-text">file_copy</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></mat-header-row>
      <mat-row *matRowDef="let event; columns: displayedColumns();"
               class="event-row"
               matRipple
               [style.background-color]="event.dayColor"
               [routerLink]="['/pages/event/detail']"
               [queryParams]="{id: event.id}">
      </mat-row>

    </mat-table>
    <mat-paginator [length]="pagination()?.total"
                   [pageIndex]="pageIndex()"
                   [pageSize]="perPage()"
                   [pageSizeOptions]="[25, 50, 100]"
                   (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
</pages-container>
